import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { scAxiosAdmin, scAxios } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import RadioGroupFunctional from "../RadioGroupFunctional";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import thanas from "../../assets/data/thana.json";
import { error } from "jquery";
import banner_img from "../../images/banner-profile.jpg";
const Mortuary = () => {
  return (
    <div>
      <SEO
        title="Mortuary | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="mortuary"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="" style={{ backgroundColor: "#fef3e9" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <section className="termscondbody mt-4 pb-4">
          <div className="container p-3">
            {/* <h2 className="text-secondary">MORTUARY</h2> */}
            <h3
              className="text-center"
              style={{
                color: "#0C807D",
                fontWeight: "700",
              }}
            >
              MORTUARY
            </h3>
            <div className="row g-3 w-100 mx-auto">
              <div className="col-md-12 d-flex">
                <div className="content mt-3 w-100 p-3">
                  <p className="text-secondary">
                    Mortuary Freezer of United Hospital is of Italian origin and
                    is made of stainless steel. It has two separate cold
                    chambers and can accommodate two dead bodies at a time at
                    two different chambers. Working temperature of mortuary is
                    00 c and temperature range can be varied from -50 c to +50
                    c. Temperature of cold chamber is being maintained and
                    checked by Biomedical Department in coordination with Duty
                    Manager.
                  </p>
                  <p className="text-secondary mt-4">
                    Since we have two chambers, so the preference is given to In
                    patients. However, if the space is available then only out
                    door bodies are also allowed to be preserved for short
                    duration.
                  </p>
                  <p className="text-secondary mt-4">
                    In addition to the mortuary, we have a proper place for
                    washing of dead bodies prior to burial.{" "}
                  </p>
                  <p className="text-secondary mt-4">
                    Hospital authority always take this responsibility as their
                    morale duty to ensure proper respect and handling of the
                    dead bodies preserved in the hospital mortuary
                  </p>
                  {/* <p className='text-secondary text-center'>{menubars.company}</p> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Mortuary;



// WEBPACK FOOTER //
// ./src/component/frontend/Mortuary.js